import "./home.sass";
import { ReportingBody } from "../reporting/reporting-body";
import { HeaderNav } from "./header-nav";
import { createContext, useRef, useState } from "react";
import { LOCALSTORAGEKEYS } from "../../common/constants";


export const ReportingContext = createContext();

  

export const Home = () => {
  const designRef = useRef({});
  const workspaceRef = useRef();
  const workSpacePermissions = useRef([]);
  // const reportingNameRef = useRef();
  // const workspaceNameRef = useRef();
  // const [workSpace, setWorkSpace] = useState();
  const [workSpaceName, setWorkSpaceName] = useState();
  const [reportingName, setReportingName] = useState();
  const [favourites, setFavourites] = useState(JSON.parse(localStorage.getItem(LOCALSTORAGEKEYS.FAVOURITES)));
  const [expirationTime, setReportingExpirationTime] = useState();


  const changeDesignObject = (designObject) => {
    if (!designObject) {
      designRef.current = {};
    } else {
      designRef.current = { ...designObject };
    }
  };

  const getDesignComponentName = () => {
    return designRef?.current?.component;
  };
  const setCurrentWorkSpace = (val) => {
    localStorage.setItem(LOCALSTORAGEKEYS.CURRENT_WORKSPACE, val);
    // setWorkSpace(val);
    workspaceRef.current = val;
  };

  const setCurrentWorkSpaceName = (val) => {
    localStorage.setItem(LOCALSTORAGEKEYS.CURRENT_WORKSPACE_NAME, val);
    // workspaceNameRef.current = val;
    setWorkSpaceName(val);
  };
  const getCurrentWorkSpace = () => workspaceRef.current ?? localStorage.getItem(LOCALSTORAGEKEYS.CURRENT_WORKSPACE) ?? "";
  // const getCurrentWorkSpace = () => workSpace ?? localStorage.getItem(LOCALSTORAGEKEYS.CURRENT_WORKSPACE) ?? "";

  // const getCurrentWorkSpaceName = () => workspaceNameRef.current ?? localStorage.getItem(LOCALSTORAGEKEYS.CURRENT_WORKSPACE_NAME) ?? "";
  const getCurrentWorkSpaceName = () => workSpaceName ?? localStorage.getItem(LOCALSTORAGEKEYS.CURRENT_WORKSPACE_NAME) ?? "";

  const setReportingConfig = (val) => {
    localStorage.setItem(LOCALSTORAGEKEYS.REPORTCONFIG, val);
  };

  const getReportingConfig = () => {
    localStorage.getItem(LOCALSTORAGEKEYS.REPORTCONFIG);
  };

  const setFavReports = (val) => {
    let fav = getLocalFavItem();
    if (fav === null) {
      let temp = [];
      temp.push(val);
      localStorage.setItem(LOCALSTORAGEKEYS.FAVOURITES, JSON.stringify(temp));
      setFavourites(JSON.stringify(temp));
    } else {
      const index = fav?.indexOf(val);
      if (index > -1) {
        fav.splice(index, 1);
        localStorage.setItem(LOCALSTORAGEKEYS.FAVOURITES, JSON.stringify(fav));
        setFavourites(JSON.stringify(fav));
      } else {
        fav.push(val);
        localStorage.setItem(LOCALSTORAGEKEYS.FAVOURITES, JSON.stringify(fav));
        setFavourites(JSON.stringify(fav));
      }
    }
  };

  const getFavReports = () => {
    return favourites;
  };

  const getLocalFavItem = () => {
    const storedValue = localStorage.getItem(LOCALSTORAGEKEYS.FAVOURITES);
    return storedValue ? JSON.parse(storedValue) : [];
  };

  const getReportName = () => {
    return reportingName;
  };

  const setReportName = (val) => {
    setReportingName(val);
  };

  const getWorkSpacePermissions = () => {
    return workSpacePermissions.current;
  };

  const setWorkSpacePermissions = (val) => {
    workSpacePermissions.current = val ?? [];
  };

  const ReportingContextValue = {
    getReportingConfig,
    setReportingConfig,
    getCurrentWorkSpace,
    getCurrentWorkSpaceName,
    setCurrentWorkSpace,
    setCurrentWorkSpaceName,
    getDesignComponentName,
    changeDesignObject,
    expirationTime,
    setReportingExpirationTime,
    setReportName,
    getReportName,
    getWorkSpacePermissions,
    setWorkSpacePermissions,
    setFavReports,
    getFavReports,
  };



  return (
    <ReportingContext.Provider value={ReportingContextValue}>
      <div className="reporting">
        
        <div
          className="header"
          style={{
            backgroundColor: "#f1f5fe",
            borderColor: "transparent",
            borderBottom: "1px solid rgba(158, 158, 158, 0.1)",
            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.05)",
          }}
        >
          <HeaderNav />
        </div>
       
        <div className="body" style={{ backgroundColor: "#fdfdff" }}>
         
          <ReportingBody />
         
        </div>
          
      </div>
    </ReportingContext.Provider>
  );
};
